module.exports = __webpack_public_path__ + "static/media/harmonium.914f6dcb.png";